import { useState, useEffect } from "react";
import { UseFormReturn } from "react-hook-form";

import { LocationData } from "../../../../../../../models/LocationData";
import { generateDefaultValues, Schema } from "../../../schema";
import { CategoryAutocompleter } from "../../CategoryAutocompleter";

export const useCategoryInitialization = (
  form: UseFormReturn<Schema>,
  locationData: LocationData
) => {
  const [categoriesInitialized, setCategoriesInitialized] = useState(
    CategoryAutocompleter.current !== undefined
  );

  // Failsafe to ensure that the category autocompleter is initialized
  useEffect(() => {
    if (!categoriesInitialized) {
      CategoryAutocompleter.initialize().then(() => {
        setCategoriesInitialized(true);
        form.reset(generateDefaultValues(locationData));
      });
    }
  }, [categoriesInitialized, form, locationData, setCategoriesInitialized]);

  return { categoriesInitialized };
};
